import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="filter-toggle"
export default class extends Controller {
  static targets = ["filters", "iconExpanded", "iconCollapsed", "collapsedSummary"];

  connect() {
    const saved = localStorage.getItem("reports-filters-open");
    if (saved !== null) {
      this.open = saved === "true";
    } else {
      this.open = window.innerWidth >= 640;
    }
    this.#apply();
  }

  toggle() {
    this.open = !this.open;
    localStorage.setItem("reports-filters-open", this.open);
    this.#apply();
  }

  #apply() {
    this.filtersTargets.forEach((target) => {
      target.classList.toggle("hidden", !this.open);
    });
    if (this.hasIconExpandedTarget)
      this.iconExpandedTarget.classList.toggle("hidden", !this.open);
    if (this.hasIconCollapsedTarget)
      this.iconCollapsedTarget.classList.toggle("hidden", this.open);
    if (this.hasCollapsedSummaryTarget)
      this.collapsedSummaryTarget.classList.toggle("hidden", this.open);
  }
}
